import React from 'react';
import { Link } from 'react-router-dom';
import { useAuthContext } from '../../context/AuthContext';
import { Button } from 'flowbite-react'

const Navbar: React.FC = () => {
  const { user, signOut } = useAuthContext();

  return (
    <nav className='px-4 py-3 flex justify-between items-center'>
      <Link
        to='/dashboard'
        className='text-white text-3xl font-extrabold tracking-widest uppercase'
      >
        <span className='text-lightblue'>The </span>
        <span className='text-white'>Clubhouse</span>
        <div className="flex flex-column">
          <span className='text-sm'>Powered by From the Pitchside</span>
        </div>
      </Link>

      {user && (
        <Button pill
          onClick={signOut}
          className='text-sm bg-lightblue text-white px-3 py-1 hover:bg-gray-100 transition'
        >
          Sign Out
        </Button>
      )}
    </nav>
  );
};

export default Navbar;
